export { Loader } from "./Loader";
export type { LoaderProps } from "@mantine/core";
